export default {
  'acc103.action.SAVE': '保存',
  'acc103.action.ATTACH': '补充附件',
  'acc103.action.VOID': '作废',
  'acc103.status.CONFIRMED': '已计入',
  'acc103.title': '费用发票管理',
  'acc103.month': '凭证月份',
  'acc103.merchant': '商家',
  'acc103.receiptDate': '凭证日期',
  'acc103.receiptNumber': '凭证号码',
  'acc103.currency': '原币币种',
  'acc103.grossAmount': '原币含税金额',
  'acc103.taxAmount': '原币税额',
  'acc103.remarks': '备注',
  'acc103.duplicateReason': '重复新建原因',
  'acc103.linkMode': '关联方式',
  'acc103.sourceMonth': '支出／预算所属月份',
  'acc103.cashEntryId': '已有手工支出',
  'acc103.fixedCode': '固定费用',
  'acc103.paidDate': '实际付款日期',
  'acc103.paidJpy': '日元实付金额',
  'acc103.status': '登记状态',
  'acc103.actions': '操作',
  'acc103.reload': '重新加载',
  'acc103.new': '新增凭证',
  'acc103.edit': '编辑',
  'acc103.view': '查看',
  'acc103.void': '作废',
  'acc103.close': '关闭',
  'acc103.history': '变更历史',
  'acc103.actor': '操作人',
  'acc103.saveDraft': '保存草稿',
  'acc103.saveLink': '保存并关联',
  'acc103.saved': '保存成功',
  'acc103.openOriginal': '打开原登记组',
  'acc103.camera': '拍照',
  'acc103.upload': '相册／文件',
  'acc103.fileHint':
    'JPEG / PNG / WebP / PDF，单文件最多10MB、PDF最多10页。一次登记一份凭证，可补件，不自动拆分支出。',
  'acc103.preview': '原件预览',
  'acc103.previewFailed': '原件读取失败，请重新选择附件重试。',
  'acc103.noFile': '选择或上传原件',
  'acc103.aiNotice':
    '选中的原件将发送至MiniMax中国站。识别结果需人工核对，不会自动入账。是否继续？',
  'acc103.aiDisabled': 'AI尚未配置或未完成真实图片验收。可正常手工填写、保存草稿及关联。',
  'acc103.recognize': 'AI识别／重试',
  'acc103.pages': '已处理页数',
  'acc103.applyWarning': '将应用识别字段，请核对金额、日期及多税率信息。',
  'acc103.apply': '应用识别结果',
  'acc103.stale': '草稿或表单已变化，请保存后重新识别，避免覆盖人工内容。',
  'acc103.currencyHint': '请输入三位大写币种代码，例如JPY、USD。',
  'acc103.duplicateHint': '遇到重复文件或疑似重复凭证时，请关联原组；确需新建时说明原因。',
  'acc103.link': '支出关联',
  'acc103.budget': '既有预算',
  'acc103.difference': '实际凭证与预算差额',
  'acc103.budgetHint': '仅关联凭证并展示差异，不替换预算、不增加支出。',
  'acc103.syncPayment': '同时同步原支出的实际日期和金额（将影响损益及现金预测）',
  'acc103.linkedPayment': '关联支出的当前状态',
  'acc103.paymentHint':
    '新增费用需填写实际付款日期、日元实付金额。不完整时请保存草稿；原币税额仅作凭证信息。',
  'acc103.voidWarning': '仅作废凭证，原支出和付款保持不变。是否继续？',
  'acc103.mode.NEW': '新增费用',
  'acc103.mode.EXISTING': '关联已有手工支出',
  'acc103.mode.FIXED': '关联固定费用',
  'acc103.status.DRAFT': '草稿',
  'acc103.status.REGISTERED': '已登记',
  'acc103.status.VOID': '已作废',
  'acc103.status.QUEUED': '排队中',
  'acc103.status.RUNNING': '识别中',
  'acc103.status.SUCCEEDED': '识别完成',
  'acc103.status.FAILED': '识别失败',
  'acc103.error.FAILED': '操作失败，输入已保留，请核对后重试。',
  'acc103.error.INVALID': '请检查输入、日期和金额格式。',
  'acc103.error.CONFLICT': '记录已变化，请重新打开并核对最新内容。',
  'acc103.error.DUPLICATE': '发现重复文件或疑似重复凭证，请打开原登记组补充，或填写新建原因。',
  'acc103.error.NOT_FOUND': '记录不存在或不可访问。',
  'acc103.error.REGISTER_REQUIRED': '已登记凭证请使用保存并关联。',
  'acc103.error.PAYMENT_REQUIRED': '请填写实际付款日期和日元实付金额，或仅保存草稿。',
  'acc103.error.SYNC_REQUIRED': '付款信息已变化，请核对并勾选同步原支出。',
  'acc103.error.PAYMENT_INVALID': '支出日期、金额或版本不正确，请核对后重试。',
  'acc103.error.FILE_LIMIT': '单文件须在10MB以内，且不能为空。',
  'acc103.error.FILE_TYPE': '文件内容不是有效的JPEG、PNG、WebP或PDF。',
  'acc103.error.PDF_LIMIT': 'PDF须未加密且不超过10页。',
  'acc103.error.IMAGE_LIMIT': '图片尺寸过大，请缩小后上传。',
  'acc103.error.ATTACHMENT_LIMIT': '每组最多10个附件、累计20页。',
  'acc103.error.AI_DISABLED': 'AI未启用，请手工填写或联系管理员完成视觉验收。',
  'acc103.error.CONSENT_REQUIRED': '发送识别前需明确同意。',
  'acc103.error.AI_LIMIT': '订阅额度不足或触发限流，请稍后手动重试。',
  'acc103.error.AI_ACCESS': '订阅密钥无权限，请管理员核对配置。',
  'acc103.error.AI_TIMEOUT': '识别超时或网络不可用，原件已保留，可手动重试。',
  'acc103.error.AI_FAILED': '识别未成功，原件已保留，可手工填写或手动重试。',
  'acc103.error.AI_INVALID': '识别结果不完整或格式不正确，请人工核对后重试。',
  'acc103.error.INTERRUPTED': '上次识别中断，没有自动重试。请核对后手动重试。',
  'acc103.expenseName': '费用名称',
  'menu.accounting.expense-invoices': '费用发票管理',
};
